import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=1cc88271"
import script from "./EditModal.vue?vue&type=script&lang=ts"
export * from "./EditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports